import axios from "axios";
import myAppConfig from "../../config";


const getAuth = async () => {
  try {
    const response = await axios.post(
      myAppConfig.api.ENDPOINT + "/api/v1/login/verify-token",
      {},
      { withCredentials: true }
    );
    return response.data;
  } catch (error) {
    throw new Error("User not authenticated");
  }
};

const login = async (credentials) => {
  try {
    // Utiliser le même format que l'original
    const bodyFormData = new FormData();
    bodyFormData.append("username", credentials.email.toLowerCase());
    bodyFormData.append("password", credentials.password);
    
    const url = myAppConfig.api.ENDPOINT + "/api/v1/login/get-access-token";
    
    const response = await axios.post(url, bodyFormData, { 
      withCredentials: true
    });
    return response;
  } catch (error) {

    throw error;
  }
};

const register = async (userData) => {
  try {
    const url = myAppConfig.api.ENDPOINT + "/api/v1/register";
    console.log("📝 Tentative d'inscription vers:", url);
    
    const response = await axios.post(url, userData, { 
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    console.log("✅ Réponse d'inscription:", response.data);
    return response;
  } catch (error) {
    console.error("❌ Erreur d'inscription:", error.response?.data || error.message);
    throw error;
  }
};

const loginWithGoogle = async (credential) => {
  try {
    const url = myAppConfig.api.ENDPOINT + "/api/v1/login/google-auth";
    const response = await axios.post(url, { credentials: credential }, {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
}

const forgotPassword = async (emailData) => {
  try {
    const response = await axios.post(
      myAppConfig.api.ENDPOINT + "/api/v1/forgot-password",
      emailData,
      { withCredentials: true }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const logout = async () => {
  try {
    await axios.post(
      myAppConfig.api.ENDPOINT + "/api/v1/logout",
      {},
      { withCredentials: true }
    );
  } catch (error) {
    throw new Error();
  }
}

const refresh = async () => {
  try {
    const response = await axios.post(
      myAppConfig.api.ENDPOINT + "/api/v1/login/refresh-token",
      {},
      { withCredentials: true }
    );
    return response;
  } catch (error) {
    throw error;
  }
}

const DataService = {
  getAuth,
  login,
  loginWithGoogle,
  register,
  forgotPassword,
  logout,
  refresh
};

export default DataService;
